// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__0iPFV","title":"style_title__PAtGu","answerItem":"style_answerItem__jA8To","active":"style_active__iq0TZ"};